/* Runtime renderer for the head model in ./head.mjs.

   The same model is rendered to static HTML at build time by
   scripts/prerender.mjs, so crawlers get the correct title/description/
   canonical/hreflang/JSON-LD in the served HTML, and this component keeps
   them in sync while the user navigates the SPA. Add new tags in head.mjs,
   never here. */

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buildHead, normalizeRoute } from './head.mjs';

const Seo = () => {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const lang = ['sr', 'en', 'de'].includes(i18n.language) ? i18n.language : 'sr';

  // useLocation() is basename-relative, so pathname is already the logical route.
  const route = normalizeRoute(pathname);
  const {
    htmlLang, title, metas, links, jsonLd,
  } = buildHead(route, lang, t);

  return (
    <Helmet htmlAttributes={{ lang: htmlLang }}>
      {title && <title>{title}</title>}

      {metas.map((m, i) => (
        m.property
          ? <meta key={`m${i}`} property={m.property} content={m.content} />
          : <meta key={`m${i}`} name={m.name} content={m.content} />
      ))}

      {/* hrefLang is only spread in when present - Helmet's DOM updater writes
          every key it is given, so passing undefined yields hreflang="undefined". */}
      {links.map((l, i) => (
        l.hrefLang
          ? <link key={`l${i}`} rel={l.rel} hrefLang={l.hrefLang} href={l.href} />
          : <link key={`l${i}`} rel={l.rel} href={l.href} />
      ))}

      {jsonLd.map((block, i) => (
        <script key={`s${i}`} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
